module.exports = __webpack_public_path__ + "img/secure-on-fill.8bbea0ff.svg";